import { render } from "./productPage.vue?vue&type=template&id=0dd9e7ce&scoped=true"
import script from "./productPage.vue?vue&type=script&lang=js"
export * from "./productPage.vue?vue&type=script&lang=js"

import "./productPage.vue?vue&type=style&index=0&id=0dd9e7ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dd9e7ce"]])

export default __exports__